import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { TOnlineBankWithProvider } from './BankSelectionModal.types';

export type ModalStep = 'choose' | 'connect' | 'success';

export const useBankSelectionFlow = (initialStep: ModalStep = 'choose') => {
    const [step, setStep] = useState<ModalStep>(initialStep);
    const [selectedBank, setSelectedBank] =
        useState<TOnlineBankWithProvider | null>(null);

    const selectBank = (bank: TOnlineBankWithProvider) => {
        tracking.ampli.trueLayerBankSelection({
            bankId: bank.bank_id,
            bankName: bank.bank_name
        });

        setSelectedBank(bank);
        setStep('connect');
    };

    const unselectBank = () => {
        setSelectedBank(null);
        setStep('choose');
    };

    const linkAnother = () => {
        setSelectedBank(null);
        setStep('choose');
    };

    return {
        step,
        selectedBank,
        selectBank,
        unselectBank,
        linkAnother
    };
};
